import Abalone from "GamesStation/bgaGames/Abalone"
import Octi from "GamesStation/bgaGames/Octi"
import Damas from "GamesStation/bgaGames/Damas"
import Quoridor from "GamesStation/bgaGames/Quoridor"
import Hidden from "GamesStation/bgaGames/Hidden"
import Mancala from "GamesStation/bgaGames/Mancala"
import Moonwalk from "GamesStation/bgaGames/Moonwalk"
import CodeBreaker from "GamesStation/bgaGames/CodeBreaker"
import Diamonds from "GamesStation/bgaGames/Diamonds"
import Wizards from "GamesStation/bgaGames/Wizards"
import TreasureIsland from "GamesStation/bgaGames/TreasureIsland"
import RedCard from "GamesStation/bgaGames/RedCard"
import BattleSubmarine from "GamesStation/games/BattleSubmarine"
import Domino from "GamesStation/games/Domino"
import Gamao from "GamesStation/games/Gamao"
import MiniBridge from "GamesStation/games/MiniBridge"
import Perudo from "GamesStation/bgaGames/Perudo"
import RushHour from "GamesStation/games/RushHour"
import Yams from "GamesStation/games/Yams"
import WolfAndSheep from "GamesStation/bgaGames/WolfAndSheep"
import Mindsters from "GamesStation/bgaGames/Mindsters"
import TicTacToe from "GamesStation/bgaGames/TicTacToe"

export {
  Abalone,
  Octi,
  Damas,
  Quoridor,
  Hidden,
  Mancala,
  Moonwalk,
  CodeBreaker,
  Diamonds,
  Wizards,
  TreasureIsland,
  RedCard,
  BattleSubmarine,
  Domino,
  Gamao,
  MiniBridge,
  Perudo,
  RushHour,
  Yams,
  Mindsters,
  TicTacToe,
  WolfAndSheep
}
